import classNames from "classnames/bind";
import style from "./ListConfig.module.css";
import { Chip, Col, Row, SelectBox, SelectBoxItem, Switch } from "../../../../components";
import { useState, useRef, useEffect } from "react";
import { convertTimePM } from "../../../../utils";
import { Fragment } from "react";

const cx = classNames.bind(style);

function ListConfig({ listParamConfig, onChangeParam }) {
    const [isFormTime, setIsFormTime] = useState(false)
    const refBtn = useRef();
    const ref = useRef();
    useEffect(() => {
        let handler = (e) => {
            if (!refBtn?.current?.contains(e.target)) {
                if (!ref?.current?.contains(e.target)) {
                    setIsFormTime(false);
                }
            }
        };
        document.addEventListener("click", handler);
        return () => {
            document.removeEventListener("click", handler);
        };
    }, []);

    const onChangeValue = (key, value) => {
        onChangeParam(key, value)
    }
    const renderItem = (component) => {
        switch (component?.key) {
            case 'SWITCH':
                return <Switch value={component.value} onChange={(data) => onChangeValue(component.id, data)} type="small" />
            case 'SELECT_BOX':
                return (
                    <SelectBox
                        onChange={(data) => onChangeValue(component.id, data)}
                        type="small"
                        className={cx('select-box')}
                        values={component?.listChild?.find(it => it.value === component?.value)?.label || 'Tất cả'}
                    >
                        {component?.listChild?.length > 0 ?
                            component.listChild.map(item => {
                                return (
                                    <SelectBoxItem key={`${item.value}_${item.label}`} value={item.value} label={item.label} />
                                )
                            }) :
                            <></>}
                    </SelectBox>
                )
            case 'TIME_FRAME':
                const [start, end] = component.value;
                return (
                    <div
                        style={{ cursor: "pointer", position: "relative" }}
                        className={cx("item-setting")}
                    >
                        <span
                            style={{
                                flex: 2,
                                display: "flex",
                                gap: 6,
                                flexWrap: "wrap",
                                flexDirection: "row-reverse",
                                marginTop: 0,
                            }}
                            className={cx("info")}
                            onClick={() => {
                                setIsFormTime(!isFormTime);
                            }}
                        >
                            <span ref={refBtn} className={cx("list-time")}>
                                {/* eslint-disable-next-line */}
                                {start && end && (
                                    <Chip
                                        title={`${convertTimePM(start)} - ${end === "00" ? "24" : convertTimePM(end)
                                            }`}
                                        onClose={() => 0}
                                    />
                                )}
                            </span>
                        </span>
                        {isFormTime && (
                            <div ref={ref} className={cx("time")}>
                                <div className={cx("start")}>
                                    <label className={cx("label-time")}>Giờ bắt đầu</label>
                                    <input
                                        value={start}
                                        onChange={(e) => onChangeValue(component.key, e.target.value)}
                                        className={cx("input-time")}
                                        type={"time"}
                                    />
                                </div>
                                <div
                                    onChange={(e) => onChangeValue(component.key, e.target.value)}
                                    className={cx("end")}
                                >
                                    <label className={cx("label-time")}>Giờ kết thúc</label>
                                    <input value={end} className={cx("input-time")} type={"time"} />
                                </div>
                            </div>
                        )}
                    </div>
                )
            case 'TIME_SAVE':
                return (
                    <input
                        onChange={(e) => onChangeValue(component.id, e.target.value)}
                        max={14}
                        min={1}
                        className={cx("date")}
                        type="number"
                        value={component.value}
                    />
                )
            case 'INPUT':
                return (
                    <input
                        onChange={() => 0}
                        className={cx("date")}
                        value={''}
                        {...component}
                    />
                )
            default:
                return <></>
        }
    }

    return (
        <div className={cx('wrapper_list')}>
            {listParamConfig?.map((item, index) => {
                return (
                    <Fragment key={`${item.title}_${index}`}>
                        <Row gap={[0, 16]} style={{ minHeight: 42 }} >
                            <Col span={6}>
                                <div className={cx("name")}>
                                    {item.title}
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className={cx("control")}>
                                    {renderItem(item)}
                                </div>
                            </Col>
                        </Row>
                        <div className={cx('border')}></div>
                    </Fragment>
                )
            })}
        </div>
    )
}

export default ListConfig;